import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
// Vendor Components
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from 'material-ui/Dialog';
import { Form, Field } from "react-final-form";
import { FORM_ERROR } from "final-form";
// Custom Components
import { TextFieldAdapter } from '../Form/TextFieldAdapter';
import { FormIcon } from '../Form/FormIcon';
import AuthStepper from '../Stepper/AuthStepper';
import Snackbar from 'material-ui/Snackbar';
import SelectField from 'components/SelectField'

// Steps
import LoginStep from '../Form/Steps/LoginStep';
import SignUpStep from '../Form/Steps/SignUpStep';
import PaymentStep from '../Form/Steps/PaymentStep';
import VerificationStep from '../Form/Steps/VerificationStep';
import ConfirmStep from '../Form/Steps/ConfirmStep';
import PasswordResetStep from '../Form/Steps/PasswordResetStep';

import moment from 'moment-timezone';


import styled from 'styled-components';
// Utilities
import { required, isEmail, composeValidators, isNum, passwordsMustMatch } from '../Form/validation';

let _submitting;
let _pristine;

class ConfirmGetMaple extends Component {
    
    state = {
        errors: {
            code: '',
            message: ''
        },
        finalStep: null,
        selectedProvince: {
            value: null
        },
        snackAutoHideDuration: 4000,
        snackMessage: '',
        snackOpen: false,
        stepToShow: 0,
    };
    
    handleSelectProvince = (selectedProvince) => {
        // console.log('VALUE OF SELECT', selectedProvince);
        this.setState({
            selectedProvince
        }, ()=> {
            // this.props.onSetPercentTax(this.state.selectedProvince.value)
            // console.log('this.state.selectedProvince', this.state.selectedProvince);
        })
        
    }

    handleCloseDialog = () => {
        // console.log('%cCLOSING DIALOG...','color: gold');
        this.props.handleClose();
        // this.resetDialog();
        // this.determineAuthFlowRequirement();
    }

    // BUTTONS

    getActionButton = ({label= "Next", form= null, primary= true, secondary= false, isNextButton= true, action= () => { return null }, raised = true, disabled=false}) => {
        const isForm = !!form;
        const formType = (isForm) ? "submit" : "button";
        return (raised) 
        ?   <RaisedButton
                label={label}
                type={formType}
                onSubmit={(event)=>{ 
                    event.preventDefault();
                }}
                onClick={(event)=>{
                    action(event);
                    if (isNextButton && !!this.props.userId) { this.advanceStepper(); }
                }}
                form={form}
                disableTouchRipple={true}
                disableFocusRipple={true}
                primary={primary}
                secondary={secondary}
                style={{marginRight: 12}}
                disabled={disabled}
            />
        :   <FlatButton
                label={label}
                type={formType}
                onSubmit={(event)=>{ 
                    event.preventDefault();
                }}
                onClick={(event)=>{
                    if (isNextButton) { this.advanceStepper(); }
                    action(event);
                }}
                form={form}
                disableTouchRipple={true}
                disableFocusRipple={true}
                primary={primary}
                secondary={secondary}
                style={{marginRight: 12}}
                disabled={disabled}
            />;
    }

    getCancelButton = (handleClose) => {
        return (
            <FlatButton
                label="Cancel"
                disableTouchRipple={true}
                disableFocusRipple={true}
                onClick={(event)=>{
                    this.setState({
                        selectedProvince: {
                            label: null,
                            value: null,
                        }
                    });
                    handleClose();
                    // this.props.resetErrors();
                    // this.resetErrors(reset)
                    // this.resetStepper();
                }}
                style={{marginRight: 12}}
            />
        );
    }

    setFinalStep = (finalStep) => {
        this.setState({
            finalStep: finalStep
        });
    }

    render() {
        const { title, handleClose, open, user } = this.props;
        
        const { currentDialog } = this.state;
        // console.log('BOOKING', this.props.booking);
        

        const SelectField = ({ input, ...rest }) => (
            <SelectStyles>
                <SelectField 
                    {...input} 
                    {...rest} 
                    searchable 
                    value={ this.state.selectedProvince }
                    onChange={this.handleSelectProvince}
                    selectedValue={this.state.selectedProvince}
                />
            </SelectStyles>
        );
        
        return (
            <div>
                {
                    <Dialog
                        title={title}
                        modal={true}
                        open={open}
                        autoScrollBodyContent={true}
                    >
                        <div style={{ marginTop: -10, marginBottom: 10 }}>
                            {/* <h3>THIS WILL APPLY ?</h3> */}
                            <h2 style={{ marginRight: 50 }}>Choose your billing province to continue:</h2>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Form
                                    onSubmit={ (values, form) => {
                                    this.props.onSubmit(values, form.reset);
                                    // console.log('FormApi: ', form);
                                    }}
                                    // validate={tru}
                                    render={({ handleSubmit, reset, submitting, pristine, values, invalid }) => (
                                        <form 
                                            onSubmit={e => {
                                                handleSubmit(e);
                                            }}
                                        >
                                            <div>
                                                <div>
                                                    <label> Province</label>
                                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center', marginTop: 15 }}>
                                                        <FormIcon name="map-marker-alt"></FormIcon>
                                                        <Field
                                                            style={{ width: 135 }}
                                                            name="province"
                                                            component={SelectField}
                                                            
                                                            // placeholder="NL"
                                                            
                                                            options={[ 
                                                                { value: 15, label: 'NL' },
                                                                { value: 15, label: 'PE' },
                                                                { value: 15, label: 'NS' },
                                                                { value: 15, label: 'NB' },
                                                                { value: 14.975, label: 'QC' },
                                                                { value: 13, label: 'ON' },
                                                                { value: 13, label: 'MB' },
                                                                { value: 11, label: 'SK' },
                                                                { value: 5, label: 'AB' },
                                                                { value: 12, label: 'BC' },
                                                                { value: 5, label: 'YT' },
                                                                { value: 5, label: 'NT' },
                                                                { value: 5, label: 'NU' },
                                                            ]}
                                                            // validate={required}
                                                            // {NL: 15, PE: 15, NS: 15, NB: 15, QC: 14.975, ON: 13, MB: 13, SK: 11, AB: 5, BC: 12, YT: 5, NT: 5, NU: 5}
                                                        />
                                                    </div>
                                                </div>
                                                
                                                { this.state.selectedProvince.value &&
                                                    <div>
                                                        <h3> 
                                                            <span style={{ color: 'darkred' }}>
                                                                $ {(50 + (50 * this.state.selectedProvince.value/100)).toFixed(2)} will be deducted from your credits and you will be redirected to Maple's website to begin your video consultation. 
                                                            </span>
                                                            <br /><br />
                                                            You must use {this.props.clientData.email} to complete Maple registration.
                                                            <br /><br />
                                                            Would you like to continue with the transaction? 
                                                        </h3>
                                                    </div>
                                                }

                                                <div className="buttons" style={{ marginTop: 40 }}>
                                                    <div style={{ marginTop: 30 }}>
                                                        {this.getActionButton({
                                                            action: (event)=>{
                                                                this.props.onConfirmGetMaple(this.state.selectedProvince.value);
                                                                this.props.handleClose();
                                                            },
                                                            disabled: submitting || !this.state.selectedProvince.value,
                                                            isNextButton: false,
                                                            label: 'Confirm Maple Purchase',
                                                        })}
                                                        {this.getCancelButton(this.props.handleClose, null)}
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    )}
                                />
                            </div>
                        </div>
                    </Dialog>
                }
            </div>
          );
    }
  }

  const SelectStyles = styled.div`
            .Select-menu {
                display: flex;
                flex-direction: column;
                width: 100%;
            }
            .Select-option {
                display: block;
            }

            .Select-input {
                width: 100px;
            }
            .Select-arrow-zone {
                padding-top: 4px;
                padding-right: 10px;
            }
            .Select-clear {
                padding-top: 7px;
                padding-right: 4px;
            }
            
            /* DropDown Styles */
            .Selet-menu-outer > div{
                width: 100px;
            }
        `;

  const mapStateToProps = ({auth, dialog, client}) => {
    // console.log('%cSERVER ERROR @ MSTP','color: greenyellow');
    // console.log(auth.serverError);
    return {
        clientData: client.clientData,
        currentDialog: dialog.current,
        emailIsVerified: auth.verificationStatus,
        emailVerified: auth.authData.emailVerified,
        errorData: auth.serverError,
        passwordData: auth.passwordData,
        user: auth.authData,
        userEmail: (auth.authData) ? auth.authData.email : null,
        userId: (auth.authData) ? auth.authData.id : null,
    };
  }

  export default connect(mapStateToProps, actions)(ConfirmGetMaple);

  /*
  
  title
  altActionText
  mainActionText
  open 
  handleClose
  
  */


// WEBPACK FOOTER //
// ./src/js/components/Dialog/ConfirmGetMaple.jsx